<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col cols="12" lg="6">
        <b-card no-header>
          <template slot="header">
          </template>
          <b-table striped small fixed responsive="sm" :items="getTeam(teamsObj, members)" :fields="fields">
            <template slot="value" slot-scope="data">
              <strong>{{data.item.value}}</strong>
            </template>
          </b-table>
          <template slot="footer">
            <b-button @click="goBack">Back</b-button>
          </template>
        </b-card>
      </b-col>
      <b-col cols="12" xl="6">
      <transition name="slide">
      <b-card :header="captionMembers">
        <b-table :hover="hover" :striped="striped" :bordered="bordered" :small="small" :fixed="fixed" responsive="sm" :items="getMembers(members)" :fields="fieldsMembers" :current-page="currentPage" :per-page="perPage" @row-clicked="rowClicked">
          <template slot="name" slot-scope="data">
            <strong>{{data.item.name}}</strong>
          </template>
          <template slot="joined" slot-scope="data">
            <strong>{{new Date(data.item.joined).toGMTString()}}</strong>
          </template>
        </b-table>
        <nav>
          <b-pagination size="sm" :total-rows="getRowCount(members)" :per-page="perPage" v-model="currentPage" prev-text="Prev" next-text="Next" hide-goto-end-buttons/>
          <b-row class="align-items-center">
            <b-col cols="6" xl= "4" sm="2" md="2" class="mb-3 mb-xl-0" >
              <b-button v-on:click="primaryModal = true" block variant="primary">Add Member</b-button>
            </b-col>
        </b-row>
        </nav>
      </b-card>
      </transition>
    </b-col>
    </b-row>
    <b-modal title="Add a member" class="modal-primary" v-model="primaryModal" @ok="addNewMember">
      <b-form-group
            label="User role"
            label-for="roleSelect"
            :label-cols="3"
            :horizontal="true">
            <b-form-select id="roleSelect"
              :plain="true"
              :options="[
                {text: 'Select user role...',value: 'none'},
                {text: 'Coach',value: 'coach'},
                {text: 'Player',value: 'player'}
              ]"
              value="none"
              v-on:change="showRoleForm">
            </b-form-select>
          </b-form-group>
          <b-form-group
              label="Player"
              :label-cols="3"
              :horizontal="true"
              v-if="showPlayerSearch">
              <vue-bootstrap-typeahead 
              v-model="memberName"
              :data="playersArray"
              :serializer="s => s.val().name + ' ' + s.val().lastName"
              @hit="newMember = $event"/>
            </b-form-group>
            <b-form-group
              label="Coach"
              :label-cols="3"
              :horizontal="true"
              v-if="showCoachSearch">
              <vue-bootstrap-typeahead 
              v-model="memberName"
              :data="coachesArray"
              :serializer="s => s.val().name + ' ' + s.val().lastName"
              @hit="newMember = $event"/>
            </b-form-group>
    </b-modal>
  </div>
</template>

<script>
import _ from 'underscore'
import { db } from '@/config/devowqlo';
import { functions } from '@/config/devowqlo';
export default {
  name: 'Team',
  firebase: {
    teams: db.ref('teams'),
    teamsObj: { // can use keys, but v-for doesn't loop
      source: db.ref('teams'),
      asObject: true
    },
    users: db.ref('users'),
  },
  props: {
    caption: {
      type: String,
      default: 'Team id'
    },
    captionMembers: {
      type: String,
      default: 'Members'
    },
    hover: {
      type: Boolean,
      default: true
    },
    striped: {
      type: Boolean,
      default: true
    },
    bordered: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    }
  },
  data: () => {
    return {
      showPlayerSearch: false,
      showCoachSearch: false,
      memberName: '',
      playersArray: [],
      coachesArray: [],
      newMember: null,
      primaryModal: false,
      fields: [
        {key: 'key'},
        {key: 'value'},
      ],
      fieldsMembers: [
        {key: 'name'},
        {key: 'lastName'},
        {key: 'role'},
        {key: 'joined'}
      ],
      currentPage: 1,
      perPage: 5,
      totalRows: 0
    }
  },
  created() {
    //this.$route('members', db.ref('teams/' + this.$route.params.id + '/members/'))
    this.$bindAsObject('members', db.ref('teamMembers/' + this.$route.params.id + '/members/'))
  },
  methods: {
    goBack() {
      this.$router.go(-1)
      // this.$router.replace({path: '/users'})
    },
    memberNameChanged(value) {
      

      if(this.showPlayerSearch){
        this.playersArray = []
        var filteredArray = []
        this.$firebaseRefs.users.child('players').
          orderByChild("name").
          startAt(this.memberName).
          endAt(this.memberName+"\uf8ff").
          once('value', function(snap) {
            // console.log(snap.val())
              snap.forEach(function (childSnapshot) {
                //console.log(childSnapshot)
                var value = childSnapshot.val();
                filteredArray.push(childSnapshot)
              });
          });
          this.playersArray = filteredArray
      }else if(this.showCoachSearch){
        this.coachesArray = []
        var filteredArray = []
        this.$firebaseRefs.users.child('coaches').
          orderByChild("name").
          startAt(this.memberName).
          endAt(this.memberName+"\uf8ff").
          once('value', function(snap) {
            // console.log(snap)
            // console.log(snap.val())
              snap.forEach(function (childSnapshot) {

                var value = childSnapshot.val();
                filteredArray.push(childSnapshot)
              });
          });
          this.coachesArray = filteredArray
      }
     // console.log(this.newMember)
      

    },
    showRoleForm(value){
      if(value == "coach"){
        console.log("--- Coach selected ---")
        this.showPlayerSearch = false
        this.showCoachSearch = true
      }else if(value == "player"){
        console.log("Player selected... ")
        this.showPlayerSearch = true
        this.showCoachSearch = false
      }else{
        console.log("None selected")
        this.showPlayerSearch = false
        this.showCoachSearch = false
      }
    },
    getMembers(members){
      // console.log('members' + members)
      // console.log('membersValues' + Object.values(members))
      // console.log(Object.values(members))
      console.log(Object.values(members))
      if(Object.values(members).length > 1){
          return Object.values(members).slice(0, Object.values(members).length-1)
      }else{
        return []
      }
      
      // var membersArray = Object.values(members).map(function(obj) {
      //   return membersArray;
      // });
      //console.log('firebaseHolyArray: ', rooms);
    },
    getTeam(teamsObj, members){
      // console.log('membersObj' + Object.entries(members))
      // console.log('teamsObj' + teamsObj)
      // const teamDetails = Object.entries(teamsObj[this.$route.params.id])
      // console.log(teamDetails)
      //return teamDetails.map(([key, value]) => {return {key: key, value: value}})
      const teamDetails = Object.entries(teamsObj[this.$route.params.id])
      return teamDetails.map(([key, value]) => {
        if(key == "registered"){
          value = new Date(value).toGMTString()
        }
        if(key == "members"){
          return {key: key, value: Object.values(members).length - 1}
        }
        return {key: key, value: value}
      })
      //console.log(teamDetails)
      //return teamDetails
    },
    getRowCount (members) {
      if(Object.values(members).length > 1){
          return Object.values(members).length - 1
      }else{
        return 0
      }
      
    },
    teamLink (id) {
      return `teams/${id}`
    },
    rowClicked (team) {
      const teamLink = this.teamLink(team['.key'])
      this.$router.push({path: teamLink})
      // :to="{ name: 'Edit', params: {id: item['.key']} }"
    },
    addTeamButton () {
      this.$router.push({path: 'teams/addteam'})
    },
    addNewMember(){

      // db.ref('users').orderByChild("email").equalTo(this.newMember.email).once("value", snapshot => {
      //     if (snapshot.exists()){
      //       const userData = Object.values(snapshot.val());
      //       console.log("exists!", userData);
      //       db.ref('teams').child(this.$route.params.id).child('members').push
      //       db.ref('teams').child(this.$route.params.id).child('members').push({
      //           name: String(userData[0].name),
      //           email: String(userData[0].email),
      //           role: String(userData[0].role),
      //           position: String(userData[0].position)
      //       })
      //     }else{
      //       this.$router.push({path: '../users/adduser' + this.$route.params.id})
      //     }
      // });

      // this.newMember.email = ''
      const dateNow = Date.now()
      var newMemberVal = this.newMember.val()
      var newMemberKey = this.newMember.key
      var teamKey = this.$route.params.id

      console.log("NEW MEMBER", newMemberVal)

      
      // var newEmail = 'child@child.com'
      // var tutorKey = Object.keys(newMemberVal.tutor)[0]
      // var giveAccessToChild = functions.httpsCallable('giveAccessToChild');
      // giveAccessToChild({newEmail: newEmail, childId: newMemberKey, tutorId: tutorKey}).then((result)  => {
      //   // Read result of the Cloud Function.
      //   //var message = result.data.text;
      //   //console.log(message)
      //   // ...
      //   console.log(result)
      // })

      
      var memberModel = { 
        name: newMemberVal.name,
        lastName: newMemberVal.lastName,
        gender: newMemberVal.gender,
        country: newMemberVal.country,
        birthdate: newMemberVal.birthdate,
        pictureUrl: newMemberVal.pictureUrl,
        thumbPictureUrl: newMemberVal.thumbPictureUrl,
        role: newMemberVal.role,
        joined: dateNow
      }

      var teamSnap = null
      this.$firebaseRefs.teams.child(teamKey).
          once('value', function(snap) {
            teamSnap = snap
          });
      console.log(teamSnap)
      var teamSnapVal = teamSnap.val()

      var teamModel = { 
        name: teamSnapVal.name,
        category: teamSnapVal.category,
        logoUrl: teamSnapVal.logoUrl,
        thumbLogoUrl: teamSnapVal.thumbLogoUrl
      }

      var userGroup = ''
      if(newMemberVal.role == "player"){
        userGroup = "players"
      }else if(newMemberVal.role == "coach"){
        userGroup = "coaches"
      }
      //Create team member
      db.ref("teamMembers").child(teamKey).child('members').child(newMemberKey).set(memberModel)

      //Create user team
      this.$firebaseRefs.users.child(userGroup).child(newMemberKey).child('teams').child(teamKey).set(teamModel)

      

      //Add playersTeamChat
      db.ref("userChats").child(newMemberKey).child('teamChats').child('playersTeamChats').child(teamKey).set(teamModel)

      //if player
      if(newMemberVal.role == "player"){


        //add child team
        var newMemberTutorId = Object.keys(newMemberVal.tutor)[0]
        this.$firebaseRefs.users.child('parents').child(newMemberTutorId).child('childrenTeams').child(newMemberKey).child('teams').child(teamKey).set(teamModel)

        // 1. Add coach chat
        // 2. Notify to coaches
        db.ref("teamMembers").child(teamKey).child('members').
          orderByChild("role").
          equalTo('coach').
          once('value', (snap) => {
            // console.log(snap)
            // console.log(snap.val())
              snap.forEach((childSnapshot) => {

                var coachMemberKey = childSnapshot.key;

                var coachChatModel = { 
                  name: childSnapshot.val().name,
                  lastName: childSnapshot.val().lastName,
                  pictureUrl: childSnapshot.val().pictureUrl,
                  thumbPictureUrl: childSnapshot.val().thumbPictureUrl
                }
                // 1. Add coach chat
                db.ref("userChats").child(newMemberKey).child('coachChats').child(coachMemberKey).set(coachChatModel) 

                // 2. Notify to coaches 
                var notificationModel = {type: 'member' , typeId: newMemberKey, typeName: memberModel.name, action: "joined", timestamp: Date.now(), viewed: false }

                console.log("<-- NOTIFY TO COACH TEAM");
                console.log(notificationModel);
                
                db.ref('userNotifications').child(playerKey).child('notifications').push(notificationModel)
              })
          })

        //Add to playersChat
        db.ref("teamChats").child(teamKey).child('playersChat').
          once('value', (snap) => {
            var playersChatId = snap.val().chatId

            var chatMemberModel = {
              name: newMemberVal.name,
              lastName: newMemberVal.lastName
            }

            db.ref("chatMembers").child(playersChatId).child(newMemberKey).set(chatMemberModel) 

          });

        //Add tutor to parentsChat
        db.ref("teamChats").child(teamKey).child('parentsChat').
        once('value', (snap) => {
          var parentsChatId = snap.val().chatId
          var tutorVal = Object.values(newMemberVal.tutor)[0]
          var chatMemberModel = {
            name: tutorVal.name,
            lastName: tutorVal.lastName
          }

          db.ref("chatMembers").child(parentsChatId).child(newMemberTutorId).set(chatMemberModel) 
          
        });

        //Add parentsTeamChat to tutor
        db.ref("userChats").child(newMemberTutorId).child('teamChats').child('parentsTeamChats').child(teamKey).set(teamModel)

      }else if(newMemberVal.role == "coach"){

        //Add parentsTeamChat
        db.ref("userChats").child(newMemberKey).child('teamChats').child('parentsTeamChats').child(teamKey).set(teamModel)


        //Add to playersChat
        db.ref("teamChats").child(teamKey).child('playersChat').
          once('value', (snap) => {
            var playersChatId = snap.val().chatId

            var chatMemberModel = {
              name: newMemberVal.name,
              lastName: newMemberVal.lastName
            }

            db.ref("chatMembers").child(playersChatId).child(newMemberKey).set(chatMemberModel) 

          });

          //Add to parentsChat
        db.ref("teamChats").child(teamKey).child('parentsChat').
          once('value', (snap) => {
            var parentsChatId = snap.val().chatId

            var chatMemberModel = {
              name: newMemberVal.name,
              lastName: newMemberVal.lastName
            }

            db.ref("chatMembers").child(parentsChatId).child(newMemberKey).set(chatMemberModel) 

          });
      }
    },
  },
  watch: {

    memberName: _.debounce(function(mem) { this.memberNameChanged(mem) }, 500)

  }

}
</script>
